<template>
    <div class="row" :data-expand="isExpand ? true : null">
        <div class="cells" v-on:click="toggleExpand()">
            <span class="cell" data-size="status" data-align="center">
                <span class="icon-status" :data-icon="histItem.userNm == 'System' ? 'system' : 'user'" :title="histItem.userNm == 'System' ? 'System' : 'User'">System</span>
            </span>
            <span class="cell" data-size="date">
                <time datetime="">{{convertUtcTimezoneToLocal(histItem.timeLine)}}</time>
            </span>
            <span class="cell" data-size="type">
                {{ $t('AUDIT.FILTER.POLICY')}}<!--정책-->
            </span>
            <span class="cell" data-size="user">
                {{histItem.userNm}}
            </span>
            <span class="cell">
                {{$t('AUDIT.LABEL.CASE.MODIFY')}}<!--수정-->&nbsp;:&nbsp;<a href="#">{{histItem.prgrSetNm}}</a>
            </span>
            <span class="cell" data-align="center">
                <button type="button" class="buttons-icon" data-type="ghost" data-icon="expand" :data-expand="isExpand ? true : null">collapse / expand</button>
            </span>
        </div>

        <div class="expand-container">
            <div-loading v-if="isExpand && arrBfRuleInfo == null"></div-loading>
            <!-- inner tables -->
            <table class="tbl-inner" v-if="arrBfRuleInfo !== null">
                <caption>{{ $t('AUDIT.LABEL.CASE.EDIT_POLICY')}}</caption>
                <colgroup>
                    <col style="width: 185px;">
                </colgroup>
                <thead>
                <tr>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.ITEM')}}<!--항목--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.FROM')}}<!--변경 전--></th>
                    <th scope="col">{{ $t('AUDIT.LABEL.HEADER.TO')}}<!--변경 후--></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.NAME')}}<!--이름--></th>
                    <td>{{bfPlcyInfo.plcyTitl}}</td>
                    <td>{{afPlcyInfo.plcyTitl}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.DESCRIPTION')}}<!--설명--></th>
                    <td>{{bfPlcyInfo.plcyDesc}}</td>
                    <td>{{afPlcyInfo.plcyDesc}}</td>
                </tr>
                <tr>
                    <th>{{ $t('AUDIT.POLICY.APPLIED_RULES')}}<!--적용된 규칙--></th>
                    <td>
                        <span v-for="rule of arrBfRuleInfo" class="item">{{rule.ruleTitl}}</span>
                    </td>
                    <td>
                        <span v-for="rule of arrAfRuleInfo" class="item">{{rule.ruleTitl}}</span>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>
    </div>

</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ExpandPolicyModify',
        props: ['histItem'],
        data: function() {
          return {
              bfPlcyInfo: null,
              afPlcyInfo: null,
              arrBfRuleInfo: null,
              arrAfRuleInfo: null,
              isExpand: false
          }
        },
        computed: {
            ...mapGetters({
                curCmpnId: 'user/curCmpnId'
            }),
            getLocale: function() {
                return this.$i18n.locale
            },
            templateList: function() {
                return this.$store.state.templateList
            },
            getActionNotNullFlag: function() {

                if(this.ruleInfo == null){
                    return false
                }
                let isExist = false

                _.forEach(this.ruleInfo.actnVal, function(actn) {
                    if (actn.actnId !== null) {
                        isExist = true
                        return false
                    }
                })

                return isExist
            }
        },
        methods: {
            selectGovernanceRuleInfo() {

                const url = `/api/governance/audit/expand/policy/info`

                let ruleData = {
                    'cmpnId': this.curCmpnId,
                    'arrRvsnId': [this.histItem.bfRvsnId, this.histItem.afRvsnId]
                }
                this.http.post(url, ruleData)
                    .then((result) => {
                        if(result.data.status == 'ok') {

                            let arrPlcyInfo = result.data.result

                            if(arrPlcyInfo !== null && arrPlcyInfo.length > 0) {
                                this.arrBfRuleInfo = _.filter(arrPlcyInfo, { 'plcyRvsnId' : this.histItem.bfRvsnId});
                                this.arrAfRuleInfo = _.filter(arrPlcyInfo, { 'plcyRvsnId' : this.histItem.afRvsnId});
                                this.bfPlcyInfo =  _.union(this.arrBfRuleInfo, 'plcyTitl')[0]
                                this.afPlcyInfo =  _.union(this.arrAfRuleInfo, 'plcyTitl')[0]
                            }

                        } else {
                            // TODO :: Error 처리
                        }
                    }).catch(error => {
                    // TODO :: Error 처리
                });
            },
            convertUtcTimezoneToLocal: function(date) {
                return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
            },
            toggleExpand: function(){
                this.isExpand = !this.isExpand
                this.isExpand && this.arrBfRuleInfo == null ? this.selectGovernanceRuleInfo() : false

            },
            // CategoryList 에서 Category ID 로 Category Label 찾기
            getCategoryLabel(ctgId) {
                var categoryLabel = ''
                for(var ctg of this.ctgList) {
                    if(ctg.ctgId == ctgId) {
                        categoryLabel = ctg.ctgLabel
                    }
                }
                return categoryLabel
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/audit/expand/policyModify.vue